import { render, staticRenderFns } from "./SatisMasrafList.vue?vue&type=template&id=13e452c7"
import script from "./SatisMasrafList.vue?vue&type=script&lang=ts"
export * from "./SatisMasrafList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports